<copo-ecalloff-header	[copyTo]="copyTo ?? ''"
						[customerCalloffReference]="custCallOffRef ?? ''"
						[editCustomerCalloffReference]="true"
						[editCopyTo]="true"
						[editRddMode]="true"
						[nbOrderItems]="calledBatches.length"
						[rddMode]="rddMode"
						[totalWeight]="getTonnage()"
						(formChange)="onInfoEntryHeaderChange($event)"
						(init)="onInfoEntryHeaderInit($event)"></copo-ecalloff-header>

<copo-infoentry-calloff-header	[rddMode]="rddMode"
								[shipToDetails]="shipToDetails"
								[unloadingRef]="unloadingRef"
								[selectedShipTo]="selectedShipTo"
								[allowChangeOfShipto]="allowShiptoSelection"
								(applyAll)="onInfoEntryCalloffHeaderApplyAll($event)"></copo-infoentry-calloff-header>

<form [formGroup]="callOffFormGroup">
	<div formArrayName="selectedBatchesArray" *ngIf="calledBatches.length > 0">
		<div *ngFor="let batch of selectedBatchForm; let i = index;">
			<div [formGroupName]="i"
				class="calloff-batch-entry grid-column-one-full copo-container card-block grid-container card-portal"
				[ngClass]="{
					'grid-6': reqDate || fromTo,
					'grid-5': !fromTo && !reqDate
				  }">
				<div class="card-row copo-bottom-margin batch-header">
					<mat-icon svgIcon="icon-batch" class="copo-right-padding"></mat-icon>
					<div class="batch-info">
						<div class="card-content-label" translate>commercial-documents.batch-number</div>
						<div>{{calledBatches[i].batchReference}}</div>
					
						<span *ngIf="calledBatches[i].millDescription">
							<div class="card-content-label" translate>datacenter-shipment.mill</div>
							<div>{{calledBatches[i].millDescription}}</div>
						</span>
					</div>
				</div>
				<div class="card-column copo-bottom-margin batch-info batch-gap">
					<div>
						<span class="tag-tonnage">{{ getWeight(calledBatches[i]) | copoNumber:'weight':'t'
							}}</span>
					</div>

					<span>
						<div class="card-content-label" translate>ecall-off.ship-to</div>
						<div>{{calledBatches[i].originalShipToDescription}}</div>
					</span>
				</div>
				<div class="card-column form-field-width">
					<mat-form-field floatLabel="always" subscriptSizing="dynamic">
						<mat-label translate>ecall-off.unloading-reference</mat-label>
						<input matInput formControlName="unloadingReference" type="text" spellcheck="false"
							autocomplete="off" maxlength="64">
						<mat-icon class="copo-orange-text-icon" matSuffix svgIcon="md:edit"></mat-icon>
					</mat-form-field>
				</div>
				<div class="copo-grid-row-column-2">
					<mat-form-field class="copo-form-field" floatLabel="always" subscriptSizing="dynamic" *ngIf="shipToDetails && shipToDetails.length > 0 && calledBatches[i].allowChangeOfShipto === 1">
						<mat-label translate>ecall-off.requested-ship-to</mat-label>
							<mat-select [value]="calledBatches[i].shipTo" (selectionChange)="onShipToChange($event.value, i)" [compareWith]="compareShipTo">
							<mat-option *ngFor="let shipTo of shipToDetails" [value]="shipTo">
								<div class="copo-ship-to-name">{{shipTo.shipToDescription}}&nbsp;/&nbsp;{{shipTo.city}}</div>
									<div class="copo-ship-to-address">
										{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
									</div>
							</mat-option>
						</mat-select>
					</mat-form-field>
					<span *ngIf="!shipToDetails || shipToDetails.length === 0 || calledBatches[i].allowChangeOfShipto === 0">
						<div class="card-content-label" translate>ecall-off.requested-ship-to</div>
						<div>{{calledBatches[i].originalShipToDescription}}</div>
					</span>
				</div>
				<div *ngIf="reqDate && !fromTo">
					<mat-form-field floatLabel="always" subscriptSizing="dynamic">
						<mat-label translate>ecall-off.requested-date</mat-label>
						<input matInput spellcheck="false" autocomplete="off" readonly
						[matDatepickerFilter]="dateFilter"
							[copoDatepicker]="startDatepicker" [copoFormat]="formatType"
							(click)="startDatepicker.open()" #startDateInput (focus)="startDateInput.blur()"
							[min]="currentDate" formControlName="requestedDate" required>
						<mat-datepicker-toggle matSuffix class="copo-orange-text-icon" [for]="startDatepicker">
						</mat-datepicker-toggle>
						<mat-datepicker #startDatepicker [startAt]="currentDate">
						</mat-datepicker>
						<mat-error translate>ecall-off.required</mat-error>
						<mat-hint *ngIf="isWeekend(batch.value.requestedDate)" class="weekend-hint"
							translate>ecall-off.requested-date-weekend-warning</mat-hint>
					</mat-form-field>
				</div>
				<div class="dates two-fields-wrapper" *ngIf="!reqDate && fromTo">
					<mat-form-field floatLabel="always" subscriptSizing="dynamic">
						<mat-label translate>filter.number.from</mat-label>
						<input [matDatepickerFilter]="dateFilter" matInput spellcheck="false" autocomplete="off" readonly
							[copoDatepicker]="startDatepicker" [copoFormat]="formatType"
							(click)="startDatepicker.open()" #startDateInput (focus)="startDateInput.blur()"
							[max]="getMaxFromDate(batch.value.toDate)" formControlName="fromDate" required>
						<mat-datepicker-toggle matSuffix class="copo-orange-text-icon" [for]="startDatepicker">
						</mat-datepicker-toggle>
						<mat-datepicker #startDatepicker [startAt]="batch.value.fromDate">
						</mat-datepicker>
						<mat-error translate>ecall-off.required</mat-error>
						<mat-hint *ngIf="isWeekend(batch.value.fromDate)" class="weekend-hint"
							translate>ecall-off.requested-date-weekend-warning</mat-hint>
					</mat-form-field>
				<ng-container *ngIf="!reqDate && fromTo">
					<mat-form-field floatLabel="always" subscriptSizing="dynamic">
						<mat-label translate>filter.date.to</mat-label>
						<input [matDatepickerFilter]="dateFilter" matInput spellcheck="false" autocomplete="off" readonly
							[copoDatepicker]="endDatepicker" [copoFormat]="formatType"
							(click)="endDatepicker.open()" #endDateInput (focus)="endDateInput.blur()"
							formControlName="toDate" [min]="getMinToDate(batch.value.fromDate)" required>
						<mat-datepicker-toggle [for]="endDatepicker" class="copo-orange-text-icon" matSuffix>
						</mat-datepicker-toggle>
						<mat-datepicker #endDatepicker [startAt]="batch.value.toDate">
						</mat-datepicker>
						<mat-error translate>ecall-off.required</mat-error>
						<mat-hint *ngIf="isWeekend(batch.value.toDate)" class="weekend-hint"
							translate>ecall-off.requested-date-weekend-warning</mat-hint>
					</mat-form-field>
				</ng-container>
			</div>
				<div class="card-column card-column-end">
					<button type="button" mat-icon-button [matMenuTriggerFor]="menu">
						<mat-icon svgIcon="md:more_vert"></mat-icon>
					</button>
					<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
						<button type="button" mat-menu-item (click)="openDialog(calledBatches[i].comment, i)">
							<span class="calloff-comment-label" [class.edit]="calledBatches[i].comment" translate>ecall-off.exception</span>
						</button>
						<mat-divider></mat-divider>
						<button type="button" mat-menu-item (click)="onViewCard(calledBatches[i])">
							<span translate>product.table.header.view</span>
						</button>
						<mat-divider></mat-divider>
						<button type="button" mat-menu-item (click)="deleteBatch(i)">
							<span translate>eoffer.action.delete</span>
						</button>
					</mat-menu>
				</div>
			</div>
		</div>
	</div>
</form>